import React from "react";
import { COLORS } from "../constants";
import { fontSerif } from "./styles";

/**
 * BrandBar — top-left header tile containing the TAB seal (left) and the
 * "The Academic Boardroom" title (right of seal). Sits in row 1; the
 * TopNav sits as row 2 directly below.
 */
export default function BrandBar() {
  return (
    <header
      data-testid="zone-brand-bar"
      style={{
        position: "absolute",
        top: 22,
        left: 24,
        display: "flex",
        alignItems: "center",
        gap: 14,
        padding: "10px 18px 10px 12px",
        background: "rgba(11,21,48,0.62)",
        border: `1px solid ${COLORS.navyMid}`,
        borderRadius: 14,
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        boxShadow: "0 6px 24px rgba(0,0,0,0.25)",
        fontFamily: fontSerif,
        pointerEvents: "auto",
        zIndex: 5,
        maxWidth: "min(46vw, 420px)",
      }}
    >
      <div
        aria-hidden="true"
        data-testid="zone-brand-seal"
        style={{
          width: 52,
          height: 52,
          borderRadius: "50%",
          background: COLORS.navyDeep,
          border: `1.5px solid ${COLORS.gold}`,
          display: "grid",
          placeItems: "center",
          overflow: "hidden",
          boxShadow: `inset 0 0 14px rgba(230,180,80,0.12), 0 4px 14px rgba(0,0,0,0.3)`,
          flexShrink: 0,
        }}
      >
        <img
          src="/brand/tab-seal.png"
          alt=""
          width={46}
          height={46}
          style={{ display: "block", objectFit: "contain" }}
        />
      </div>
      <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.1, minWidth: 0 }}>
        <div
          style={{
            fontSize: 10,
            letterSpacing: 5,
            color: COLORS.gold,
            textTransform: "uppercase",
            marginBottom: 4,
          }}
        >
          Est · MMXXVI
        </div>
        <div
          data-testid="zone-brand-title"
          style={{
            fontSize: 20,
            color: COLORS.ivory,
            letterSpacing: 0.5,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          The Academic Boardroom
        </div>
      </div>
    </header>
  );
}
